module.exports = __webpack_public_path__ + "static/media/documentation.3f9d89e9.md";